import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import axios from "../../helpers/axios";
import {
  Layout,
  Loading,
  Notification,
  ScreenHeading,
} from "../../webtracking/components";

import { SosEtaFrom } from "../components";

const useEditUserScreen = () => {
  const { id } = useParams();
  const history = useHistory();

  const [eta, setEta] = useState(null);
  const [message, setMessage] = useState("");
  const [isLoading, setLoading] = useState(true);

  const loadEta = (id) => {
    setLoading(true);

    axios
      .get(`/api/delivery_time/${id}/`)
      .then(({ data }) => setEta(data))
      .catch((error) => {
        setMessage("No se pudo cargar el tiempo estimado.");
        console.error(error);
      })
      .then(() => setLoading(false));
  };

  useEffect(() => {
    loadEta(id);
  }, [id]);

  const handleSubmit = (values, { setSubmitting }) => {
    axios
      .put(`/api/delivery_time/${id}/`, values)
      .then(() => history.goBack())
      .catch((error) => {
        setMessage("No se pudo actualizar el documento");
        console.error(error);
      })
      .then(() => setSubmitting(false));
  };

  return {
    eta,
    message,
    isLoading,
    handleSubmit,
    history,
  };
};

const SosEtaUpdate = () => {
  const {
    eta,
    message,
    isLoading,
    handleSubmit,
    history,
  } = useEditUserScreen();

  if (isLoading) {
    return (
      <Layout>
        <Loading />
      </Layout>
    );
  }

  return (
    <Layout>
      <ScreenHeading title="Actualizar ETA" />
      <div className="container has-background-light p-6 mt-5">
        <Notification message={message} />
        <SosEtaFrom
          initial={eta}
          onSubmit={handleSubmit}
          onCancel={() => history.goBack()}
        />
      </div>
    </Layout>
  );
};

export default SosEtaUpdate;
